import React from 'react';
import MediaQuery from 'react-responsive';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';

const WidgetOnMobile = props => {
  const { renderComponent, status, toggleFunc } = props;

  return (
    <>
      <MediaQuery query="(min-width: 768px)">{renderComponent}</MediaQuery>

      <MediaQuery query="(max-width: 767px)">
        <div className="widget-on-mobile">
          {status && (
            <div className="widget-on-mobile__popup">
              <span className="widget-on-mobile__close" onClick={toggleFunc} />
              {renderComponent}
              <div className="widget-on-mobile__control">
                <BasicButton
                  btnWidth={200}
                  btnHeight={40}
                  btnFontWeight={600}
                  btnText="Close"
                  btnArrow={false}
                  btnHoverBg="#f40"
                  controlFunc={toggleFunc}
                />
              </div>
            </div>
          )}
        </div>
      </MediaQuery>
    </>
  );
};

export default WidgetOnMobile;
